module.exports = __webpack_public_path__ + "img/life.77c435ed.svg";